import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoints } from '../styles';
import { shadow2 } from '../styles/util';
import { fromThemeColors } from '../Theme';
var bladeOverlayKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tfrom { transform: translate3d(100%, 0, 0); }\n\tto { transform: translate3d(0, 0, 0); }\n"])));
var bladeOverlayReverseKeyframes = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfrom { transform: translate3d(0, 0, 0); }\n\tto { transform: translate3d(100%, 0, 0); }\n"])));
var enterStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tanimation-name: ", ";\n"])), bladeOverlayKeyframes);
var leaveStyles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tanimation-name: ", ";\n"])), bladeOverlayReverseKeyframes);
function getAnimationStyle(animationState) {
  switch (animationState) {
    case 'entered':
    case 'entering':
      return enterStyles;
    case 'exiting':
    case 'exited':
      return leaveStyles;
    default:
      return null;
  }
}
var bladeWidth = '768px';
export var StyledBlade = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\talign-items: stretch;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tmax-width: ", ";\n\toutline: none;\n\tpadding: 0px;\n\twidth: ", ";\n\tanimation: blade_animation 350ms forwards;\n\tposition: relative;\n\tbox-shadow: ", ";\n\t", "\n\t", " {\n\t\tmax-width: none;\n\t\twidth: 100%;\n\t}\n\t@media print {\n\t\tborder: none;\n\t\tbox-shadow: none;\n\t\tmax-width: none;\n\t\tmin-height: 100vh;\n\t\twidth: 100vw;\n\t}\n"])), fromThemeColors('bladeBackground'), bladeWidth, bladeWidth, shadow2.boxShadow, function (props) {
  return getAnimationStyle(props.animationState);
}, breakpoints.onMobile);